import { render, staticRenderFns } from "./rate.vue?vue&type=template&id=1181e7a2&scoped=true&"
import script from "./rate.vue?vue&type=script&lang=js&"
export * from "./rate.vue?vue&type=script&lang=js&"
import style0 from "./rate.vue?vue&type=style&index=0&id=1181e7a2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1181e7a2",
  null
  
)

export default component.exports